import { render, staticRenderFns } from "./network.vue?vue&type=template&id=2f5b3f8e&scoped=true"
import script from "./network.vue?vue&type=script&lang=js"
export * from "./network.vue?vue&type=script&lang=js"
import style0 from "./network.vue?vue&type=style&index=0&id=2f5b3f8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b3f8e",
  null
  
)

export default component.exports